/**
 * DevExtreme (esm/common/core/events/visibility_change.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import VisibilityChangeModule from "../../../__internal/events/m_visibility_change";
export const triggerShownEvent = VisibilityChangeModule.triggerShownEvent;
export const triggerHidingEvent = VisibilityChangeModule.triggerHidingEvent;
export const triggerResizeEvent = VisibilityChangeModule.triggerResizeEvent;
export default VisibilityChangeModule;